import gql from "graphql-tag";

export default gql`
	query getCart($billingInfo: BillingInfoInput!, $cartItems: [CartItemInput!]!) {
		getCart(billingInfo: $billingInfo, cartItems: $cartItems) {
			cartItems {
				platform
				subscriptionSize
				price
				newSeats
				billingPeriod
				expirationDate
				name
				subscriptionRenewPrice
				purchaseType
			}
			cartAsJSON
		}
	}
`;

export const readCart = ({ data }) => data && data.getCart;
